// extracted by mini-css-extract-plugin
export default {"faqQuestion":"Questions_faqQuestion__Gr5ce","faqAnswer2":"Questions_faqAnswer2__B8HE6","title":"Questions_title__j3FMU","arrow":"Questions_arrow__L6xVO"};